import { render, staticRenderFns } from "./edit-mobile.vue?vue&type=template&id=55f0a190&scoped=true&"
import script from "./edit-mobile.vue?vue&type=script&lang=js&"
export * from "./edit-mobile.vue?vue&type=script&lang=js&"
import style0 from "./edit-mobile.vue?vue&type=style&index=0&id=55f0a190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f0a190",
  null
  
)

export default component.exports